import React, {FC, Fragment} from 'react';
import {CloseIcon} from 'components';

import {Dialog, Transition} from '@headlessui/react';

import {PlatformFeeSettings} from './Components/PlatformFeeSettings';
import {SessionRateSettings} from './Components/SessionRateSettings';

export const PaymentSettingsModal: FC<{
  showModal: boolean;
  paymentType: 'platform_fee' | 'session_rate' | undefined;
  closeModal: () => void;
}> = ({showModal, paymentType, closeModal}) => {
  return (
    <Transition appear show={showModal} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-999"
        onClose={closeModal}
        data-testid="rating-modal"
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform rounded-2xl bg-white p-0 py-5 text-left align-middle shadow-xl transition-all">
                <button
                  onClick={closeModal}
                  className="absolute top-5 right-7 w-8 h-8 rounded-full bg-gray-100 flex justify-center items-center"
                >
                  <CloseIcon strokeColor="text-gray-700" strokeWidth={40} />
                </button>

                {paymentType === 'platform_fee' ? (
                  <PlatformFeeSettings onCancel={closeModal} />
                ) : (
                  <SessionRateSettings onCancel={closeModal} />
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
